/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_Lo as Lo,
  rec_React as React,
  rec_kr as kr,
} from "../../runtime/index.jsx";
export function RespuestaIncidencia({
  campo: e,
  valor: t,
  onElegir: n,
  onAlternar: r,
}) {
  let i = (
    <JSXRuntime.Fragment
      children={[
        e.etiqueta,
        e.obligatorio && (
          <span
            className={`text-(--error)`}
            aria-hidden={`true`}
            children={` *`}
          />
        ),
      ]}
    />
  );
  if (e.clase === `TEXTO` || e.clase === `NUMERO`)
    return (
      <label
        className={`flex flex-col gap-1 text-sm text-(--text)`}
        children={[
          <span className={`font-medium text-(--text-h)`} children={i} />,
          <input
            className={Lo}
            type={e.clase === `NUMERO` ? `number` : `text`}
            inputMode={e.clase === `NUMERO` ? `numeric` : void 0}
            value={t ?? ``}
            required={e.obligatorio}
            onChange={(e) => n(e.target.value)}
          />,
        ]}
      />
    );
  let a = e.clase === `UNICA`,
    o = a ? (t ? [t] : []) : Array.isArray(t) ? t : [];
  return (
    <fieldset
      className={`min-w-0`}
      children={[
        <legend
          className={`mb-2 text-sm font-medium text-(--text-h)`}
          children={[
            i,
            <span
              className={`ml-1 text-xs font-normal text-(--text)`}
              children={a ? `· una` : `· las que correspondan`}
            />,
          ]}
        />,
        <div
          className={`animar-cascada flex flex-wrap gap-2`}
          children={e.opciones.map((e) => {
            let t = o.includes(e.etiqueta);
            return (
              <button
                key={e.id}
                type={`button`}
                aria-pressed={t}
                onClick={() => {
                  try {
                    navigator.vibrate?.(10);
                  } catch {}
                  a ? n(t ? null : e.etiqueta) : r(e.etiqueta);
                }}
                className={`inline-flex min-h-11 items-center gap-1.5 rounded-full border-2 px-4 py-2 text-sm transition duration-150 ease-(--curva) active:scale-[0.92] focus-visible:ring-2 focus-visible:ring-(--accent-border) ${t ? `animar-pop border-(--accent) bg-(--accent) text-(--accent-fg) shadow-md` : `border-(--border) bg-(--bg) text-(--text-h) hover:border-(--accent-border)`}`}
                children={[
                  t &&
                    (0, JSXRuntime.jsx)(kr, {
                      className: `h-4 w-4 shrink-0`,
                      strokeWidth: 3,
                    }),
                  e.etiqueta,
                ]}
              />
            );
          })}
        />,
      ]}
    />
  );
}
